import { Link, useLocation } from "react-router-dom";

import { IMAGES } from "../../constant/theme";
import { useEffect, useState } from "react";

const AboutAttendance = () => {
  function StaffProfile() {
    const location = useLocation();

    const [userData, setUserData] = useState(null);

    useEffect(() => {
      setUserData(location.state?.user || null);
    }, [location.state]);

    // const userData = location.state?.user || null;

    // Prepare personal detail items dynamically
    const personalDetail = [
      { title: "Name", subtitle: userData?.coach?.name || "-" },
      { title: "Date of Birth", subtitle: userData?.coach?.dob || "-" },
      { title: "Mobile No", subtitle: userData?.coach?.contactPhone || "-" },
      { title: "Email", subtitle: userData?.coach?.email || "-" },
      { title: "Skill", subtitle: userData?.coach?.coachSkill || "-" },
      { title: "Experience", subtitle: userData?.coach?.experience || "-" },
      {
        title: "Qualification",
        subtitle: userData?.coach?.qualification || "-",
      },
      {
        title: "Session",
        subtitle: userData?.session?.name || "-",
      },
      {
        title: "Check-In Time",
        subtitle: userData?.checkInTime
          ? new Date(userData.checkInTime).toLocaleString()
          : "-",
      },
      {
        title: "Check-Out Time",
        subtitle: userData?.checkInTime
          ? new Date(userData.checkOutTime).toLocaleString()
          : "-",
      },
    ];

    console.log("userData:", userData);
    return (
      <>
        <div className="row">
          <div className="col-xl-11 col-xxl-12 col-lg-12">
            <div className="row">
              <div className="col-lg-12">
                <div className="card overflow-hidden">
                  <div
                    className="text-center p-3 overlay-box"
                    style={{ backgroundImage: `url(${IMAGES.BigImg1})` }}
                  >
                    <div className="profile-photo"></div>
                    <h3 className="mt-3 mb-1 text-white">
                      {userData?.coach?.name || "-"}
                    </h3>
                    <p className="text-white mb-0">Coach</p>
                  </div>
                  <div className=" row">
                    {personalDetail?.map((data, index) => (
                      <div
                        key={index}
                        className="list-group-item d-flex justify-content-between col-md-6 col-6"
                      >
                        <span className="mb-0">{data.title}</span>{" "}
                        <strong className="text-muted">{data.subtitle}</strong>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="page-titles d-flex justify-content-between align-items-center">
        <h4 className="mb-0">About Coach Attendance</h4>
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item ">
            <Link to="/admin/coach-attendance">Coach Attendance</Link>
          </li>
          <li className="breadcrumb-item active">
            <Link
              onClick={(e) => e.preventDefault()}
              to="#"
              style={{
                pointerEvents: "none",
                color: "inherit",
                color: "#6F77F8",
              }}
            >
              About Coach
            </Link>
          </li>
        </ol>
      </div>
      <StaffProfile />
    </>
  );
};

export default AboutAttendance;
